import { createSlice } from "@reduxjs/toolkit";

const initialGestaoSCDESState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  gestaoSCDEForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const gestaoSCDESSlice = createSlice({
  name: "gestaoSCDES",
  initialState: initialGestaoSCDESState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getGestaoSCDEById
    gestaoSCDEFetched: (state, action) => {
      state.actionsLoading = false;
      state.gestaoSCDEForEdit = action.payload.gestaoSCDEForEdit;
      state.error = null;
    },
    gestaoSCDEFetchedGraficoHorario: (state, action) => {
      state.actionsLoading = false;
      state.gestaoSCDEForEdit.graficoHorario = action.payload.graficoHorario;
      state.error = null;
    },
    // findGestaoSCDES
    gestaoSCDESFetched: (state, action) => {

      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createGestaoSCDE
    gestaoSCDECreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.gestaoSCDE);
    },
    // updateGestaoSCDE
    gestaoSCDEUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.gestaoSCDE.id) {
          return action.payload.gestaoSCDE;
        }
        return entity;
      });
    },
    // deleteGestaoSCDE
    gestaoSCDEDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deleteGestaoSCDES
    gestaoSCDESDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    // gestaoSCDESUpdateState
    gestaoSCDESStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    }
  }
});
